<template>
  <section>
    <v-row dense>
      <v-col cols="12" sm="4">
        <v-text-field
          filled
          dense
          hide-details
          :read-only="readOnly"
          :value="cash"
          label="Comptant"
          type="number"
          min="0"
          step="0.01"
          @change="e => updateProps('cash', Number(e))"
          class="no-before"
        ></v-text-field>
      </v-col>
      <v-col cols="12" sm="4">
        <v-text-field
          filled
          dense
          hide-details
          :read-only="readOnly"
          :value="tpv"
          label="Tpv (Visa + Master)"
          type="number"
          min="0"
          step="0.01"
          @change="e => updateProps('tpv', Number(e))"
          class="no-before"
        ></v-text-field>
      </v-col>
      <v-col cols="12" sm="4">
        <v-text-field
          filled
          dense
          hide-details
          :read-only="readOnly"
          :value="others"
          label="Autres"
          type="number"
          min="0"
          step="0.01"
          @change="e => updateProps('others', Number(e))"
          class="no-before"
        ></v-text-field>
      </v-col>
    </v-row>
  </section>
</template>

<script>
import round10 from "round10";
export default {
  name: "TillTips",
  props: {
    cash: {
      type: Number,
      required: true
    },
    tpv: {
      type: Number,
      required: true
    },
    others: {
      type: Number,
      required: true
    },
    total: {
      type: Number,
      required: true
    },
    valid: {
      type: Boolean,
      default: true
    },
    readOnly: {
      type: Boolean,
      default: false
    }
  },
  methods: {
    updateProps(type, value) {
      this.$emit(`update:${type}`, round10.round10(Math.abs(value), -2));
    },
    calculateTotal() {
      const total = round10.round10(this.cash + this.tpv + this.others, -2);
      this.$emit("update:total", total);
      this.$emit("update:valid", total > 0);
    }
  },
  watch: {
    cash: {
      handler: "calculateTotal"
    },
    tpv: {
      handler: "calculateTotal"
    },
    others: {
      handler: "calculateTotal"
    }
  }
};
</script>

<style lang="scss" scoped></style>
